import { createContext } from 'react'
import { ConfirmTranslateStore } from './ConfirmTranslateStore';

export const storeContext = createContext({
    confirmTranslateStore: new ConfirmTranslateStore
});
